export default {
  day: {
    format: "MM/DD",
    displayFormat: "MMM DD, YYYY",
    reportFormat: "MMM DD, YYYY",
    tableColumnFormat: "M/DD",
    intervalButtonsFormat: "MMM DD",
  },
  week: {
    format: "MM/DD",
    displayFormat: "MMM DD",
    reportFormat: "MMM DD, YYYY",
    tableColumnFormat: "M/DD",
    intervalButtonsFormat: "MMM DD",
  },
  month: {
    format: "MMM",
    displayFormat: "MMMM YYYY",
    reportFormat: "MMMM YYYY",
    tableColumnFormat: "MMM",
    intervalButtonsFormat: "MMMM",
  },
  quarter: {
    format: "Q YYYY",
    displayFormat: "Q YYYY",
    reportFormat: "MMMM YYYY",
    tableColumnFormat: "Q",
    intervalButtonsFormat: "Q YYYY",
  },
  year: {
    format: "YYYY",
    displayFormat: "YYYY",
    reportFormat: "YYYY",
    tableColumnFormat: "YYYY",
    intervalButtonsFormat: "YYYY",
  },
};
